import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { ProgressBarStyle } from './types'

@safeCustomElement('mdc-progress-bar')
export class MdcProgressBar extends LitElement {
  @property({ type: String }) variant: ProgressBarStyle = 'primary'
  @property({ type: Number }) progress = 0
  @property({ type: Boolean }) disabled = false

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-progress-bar {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			flex-shrink: 0;
			width: 100%;
			height: 0.125rem;
			border-radius: var(--radius-xs);
		}

		.mdc-progress-bar--style-primary {
			--_mdc-progress-color: var(--color-functional-gray-black);
			background-color: var(--color-functional-gray-75);
		}

		.mdc-progress-bar--style-inverse {
			--_mdc-progress-color: var(--color-functional-gray-white);
			background-color: rgba(255, 255, 255, 0.5);
		}

		.mdc-progress-bar--disabled {
			--_mdc-progress-color: var(--color-functional-gray-200);
		}

		.mdc-progress-bar__fill {
			width: var(--_mdc-progress, 0%);
			height: 100%;
			background-color: var(--_mdc-progress-color);
		}
	`

  get progressPercent(): number {
    const min = 0
    const max = 100
    return Math.min(Math.max(this.progress ?? 0, min), max)
  }

  render() {
    const className = `mdc-progress-bar mdc-progress-bar--style-${this.variant}${this.disabled ? ' mdc-progress-bar--disabled' : ''}`
    const progressStyle = `--_mdc-progress: ${this.progressPercent}%`

    return html`
			<div class=${className}>
				<div class="mdc-progress-bar__fill" style=${progressStyle}></div>
			</div>
		`
  }
}
